/**
 * hb-gallery-columns.js — galeria de producte en 2 columnes amb CSS multicol.
 *
 * PER QUE EXISTEIX AQUEST FITXER
 * El tema reparteix les imatges de la galeria en dos `<div class="media-column">`
 * creats amb jQuery (theme.js, initColumns(), ~4616-4655). El repartiment es fa
 * per COMPTE d'imatges, no per alçada:
 *
 *   elementsPerCol = Math.ceil(N / 2)    <- arrodoneix a favor de l'esquerra
 *
 * Amb nombre senar d'imatges l'esquerra en rep una mes, i com que les
 * proporcions son molt desiguals (verticals ~140% barrejades amb apaisades
 * ~67%), la columna esquerra s'allarga molt i la dreta deixa un forat blanc.
 * Mesurat: 7 imatges -> 1673px vs 957px, forat de 716px.
 *
 * QUE FA
 * `initColumns` nomes s'executa si `data-column-count === 2` (theme.js:4668).
 * Aqui posem l'atribut a "1" ABANS que theme.js el llegeixi: aixi initColumns
 * no crea cap `.media-column`, ni tampoc en els seus re-inits (canvi de
 * variant 4907-4908, resize 5182). Les imatges es queden com a germanes
 * directes de `.theme-images` i les col·loca una graella CSS.
 *
 * El layout es masonry per graella: `.theme-images` es un grid amb files d'1px
 * i cada imatge ocupa tantes files com pixels fa d'alt, via la variable
 * `--hb-span` que calculem aqui. Aixi les imatges s'enganxen verticalment sense
 * espais en blanc. El CSS viu a src/scss/components/_product-gallery.scss.
 *
 * L'alcada es dedueix de la proporcio que Liquid escriu inline en render
 * (`padding-top`), de manera que NO cal esperar que les imatges es carreguin i
 * no hi ha salts visuals. Com que els spans son en pixels, cal recalcular quan
 * canvia l'amplada de columna (resize) o el joc d'imatges (canvi de variant).
 *
 * theme.js queda INTACTE, de manera que el canvi sobreviu als updates del tema
 * Showcase. Mateix patro que assets/hb-swiper-gap.js.
 *
 * Carrega a layout/theme.liquid amb `defer` ABANS de theme.js: els scripts amb
 * `defer` s'executen en ordre de document, aixi arribem primer.
 *
 * El CSS viu a src/scss/components/_product-gallery.scss, condicionat a la
 * classe `hb-gallery--css-columns` que afegim aqui: si aquest script no
 * s'executes, el CSS no s'aplica i el tema es comporta com sempre.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 992px)'; // igual que el CSS del tema (10580)
  // Separacio vertical entre imatges. Ha de coincidir amb `$hb-gallery-gap` de
  // _product-gallery.scss, que la pinta com a `margin-bottom`; aqui la sumem al
  // span perque la graella hi reservi l'espai.
  //
  // No es pot fer amb `row-gap`: les files de la graella son d'1px, aixi que el
  // gap s'aplicaria centenars de vegades per imatge (mesurat: 2584px).
  var GAP = 0;

  var marked = [];

  /**
   * Proporcio (alcada / amplada, en %) d'una imatge, SENSE esperar que es
   * carregui: Liquid escriu el padding inline en render (snippets/media.liquid).
   */
  function ratioOf(themeImg) {
    // Nomes `.rimage-wrapper` porta el padding inline amb la proporcio; el
    // `.product-media` que l'envolta NO en te (llegir-lo donava sempre buit i
    // totes les imatges acabaven amb el mateix span).
    var boxes = themeImg.querySelectorAll('.rimage-wrapper, .product-media');
    for (var i = 0; i < boxes.length; i++) {
      var st = boxes[i].style;
      var pt = parseFloat(st.paddingTop);
      if (!isNaN(pt) && pt > 0) return pt;
      var pb = parseFloat(st.paddingBottom); // video / model 3D
      if (!isNaN(pb) && pb > 0) return pb;
    }
    return null; // sense proporcio coneguda -> el cridador fara servir l'alcada real
  }

  /**
   * Masonry per graella: cada imatge ocupa tantes files d'1px com pixels fa
   * d'alt. Cal l'amplada real de columna, per aixo es recalcula en redimensionar.
   */
  function applySpans(gallery) {
    var imgs = gallery.querySelectorAll('.theme-img');
    if (!imgs.length) return;

    var container = gallery.querySelector('.theme-images');
    if (!container) return;

    // Amplada d'una columna: la meitat del contenidor.
    var colWidth = container.offsetWidth / 2;
    if (!colWidth) return;

    Array.prototype.forEach.call(imgs, function (img) {
      // L'alcada REAL mesurada es la bona quan ja existeix: l'estimacio per
      // proporcio arrossega error d'arrodoniment. Nomes s'estima si encara no
      // te alcada (primera passada, imatges lazy sense carregar), i llavors el
      // resize/variant-change ho corregeix.
      var h = img.offsetHeight;
      if (!h) {
        var ratio = ratioOf(img);
        h = ratio !== null ? colWidth * (ratio / 100) : 0;
      }
      if (!h) return;

      // `offsetHeight` NO inclou el margin, aixi que el gap se suma un sol cop.
      // S'arrodoneix l'alcada abans de sumar-hi el gap: si s'arrodonis el total,
      // l'error d'arrodoniment es menjaria part del marge i sortiria irregular.
      img.style.setProperty('--hb-span', Math.round(h) + GAP);
    });
  }

  function refresh() {
    if (!window.matchMedia(DESKTOP).matches) return;
    marked.forEach(applySpans);
  }

  function setup() {
    var galleries = document.querySelectorAll('.theme-gallery[data-column-count="2"]');
    if (!galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      // Ordre important: primer marquem, despres desactivem el JS del tema.
      gallery.classList.add('hb-gallery--css-columns');
      gallery.setAttribute('data-column-count', '1');
      marked.push(gallery);
    });

    refresh();

    // L'amplada de columna canvia en redimensionar; els spans son en px.
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(refresh, 100);
    });

    // Canvi de variant: el tema pot mostrar/ocultar imatges (agrupacio per
    // variant), aixi que cal recalcular.
    document.addEventListener('on:variant:change', function () {
      setTimeout(refresh, 50);
    });
  }

  // El markup de la galeria pot no existir encara quan s'executa aquest script
  // (defer garanteix DOM parsejat, pero som defensius per si es mou d'ordre).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
